import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/config";

export const WhatsAppFloat = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp ile İletişim"
    data-testid="whatsapp-float"
    className="fixed bottom-6 right-6 z-40 group"
  >
    <span className="absolute inset-0 rounded-full bg-emerald-400/50 animate-ping" />
    <span className="relative flex items-center gap-2 pl-4 pr-5 py-3.5 rounded-full bg-emerald-500 text-white shadow-[0_16px_40px_-12px_rgba(16,185,129,.6)] hover:bg-emerald-600 transition-colors">
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline font-semibold text-sm">WhatsApp</span>
    </span>
  </a>
);
